import {IComponentOptions, ILogService} from "angular";
import "./application-stepper.less";

interface IStep {
    label: string;
    link: string;
}

class ApplicationStepperController {

    public show: boolean = true;
    public steps: IStep[];

    /* @ngInject */
    constructor(private $log: ILogService) {
    }

    public $onInit() {
        this.steps = [
            { label: "Personal details", link: "#personal-details" },
            { label: "Course credits", link: "#course-credits" },
            { label: "Prior studies", link: "#prior-studies" },
            { label: "Prior learning", link: "#prior-learning" },
            { label: "Attachments", link: "#attachments" },
            { label: "Declaration", link: "#declaration" }

        ];
    }
}

export const ApplicationStepperComponent: IComponentOptions = {
    bindings: {},
    controller: ApplicationStepperController,
    template: require("./application-stepper.html")
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/stepper/application-stepper.component.ts